const maskZip = ( value: string ): string => {
  const x = value.match( /(\d{0,5})/ );
  return !!x ? x[1] : '';
};


export default maskZip;
